import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: 'In order to close your account, you must transfer all of your money to another bank. In other words, you need to bring your account balance to 0.',
    title: 'Not so fast! There is money left in your account',
    transferFunds: 'Transfer my money',
  },
  fr: {
    body: 'Vous devez transférer tous vos fonds vers une autre banque avant de clôturer votre compte. Autrement dit, le solde de votre compte doit être à 0 €.',
    title: 'Pas si vite ! Il reste de l’argent sur votre compte',
    transferFunds: 'Transférer mes fonds',
  },
});

export default locales;
